import { GenericPanelData } from 'types'

export type ColumnBreakPanelData = GenericPanelData

const LATEST_DATA_SCHEMA_VERSION = 1

export const DEFAULT_COLUMN_BREAK_PANEL_DATA: ColumnBreakPanelData = {
  panelDataSchemaVersion: LATEST_DATA_SCHEMA_VERSION,
  title: 'New Column',
  isPinned: false,
}
